import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAxios from '../../../hooks/useAxios';
import {
  IGetSpeakingRubric,
  IGetSpeakingRubricCheck,
  IGetSpeakingRubricItem,
} from '../../../models/newSpeaking.model';
import { useHistory, useRouteMatch } from 'react-router-dom';
import {
  getSpeakingRubric,
  getSpeakingRubricCheck,
  getSpeakingRubricItemScale,
} from '../../../api/newSpeaking.api';
import Loader from '../../../components/Loader';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import { Descriptions } from 'antd';
import SpeakingRubricItemTable from '../../../components/cbt/speaking-rubric/SpeakingRubricItemTable';
import Button from '../../../components/Button';
import ItemSaveModal from '../../../components/cbt/speaking-rubric/modals/ItemSaveModal';
import useAuth from '../../../hooks/useAuth';
import { getCommonCodeLabel } from '../../../lib/store';

interface IMatch {
  id: string;
}

const CbtSpeakingRubricRead: FC = () => {
  const { t, i18n } = useTranslation();
  const { writeAuthYn } = useAuth();
  const {
    params: { id },
  } = useRouteMatch<IMatch>();
  const history = useHistory();
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetSpeakingRubric>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
    clear: clear2,
  } = useAxios<IGetSpeakingRubricItem>();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios<IGetSpeakingRubricCheck>();

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    execute(getSpeakingRubric(id));
    execute3(getSpeakingRubricCheck(id));
  }, []);

  const onCancel = () => {
    execute(getSpeakingRubric(id), false);
    setVisible(false);
  };

  const showModal = (evaluationNo: number) => {
    execute2(getSpeakingRubricItemScale(evaluationNo));
    setVisible(true);
  };

  const createShowModal = () => {
    clear2();
    setVisible(true);
  };

  return (
    <>
      <div className="content scrollbar">
        {(isLoading || isLoading2 || isLoading3) && <Loader />}
        <ErrorResponse error={error} />
        <ErrorResponse error={error2} />
        <ErrorResponse error={error3} />
        <SimpleHeader
          iconFile="icon-cbt-big.svg"
          parentMenu={t('common.menu.cbt')}
          currentMenu={t('cbt.speakingRubric.11')}
        />
        <div className='comm-table__area rowType'>
          <Descriptions
            bordered
            size="small"
            column={1}
            labelStyle={{ width: '25%' }}
          >
            <Descriptions.Item label={t('common.label.1')}>
              {getCommonCodeLabel('PR0006', res?.data?.eduStepCode, i18n.language)}
            </Descriptions.Item>
            <Descriptions.Item label={t('cbt.speakingRubric.3')}>
              {getCommonCodeLabel('TE0010', res?.data?.rubricType, i18n.language)}
            </Descriptions.Item>
            <Descriptions.Item label={t('cbt.speakRubric.column1')}>
              {res?.data?.rubricName}
            </Descriptions.Item>
            <Descriptions.Item label={t('cbt.speakRubric.column2')}>
              {res?.data?.useYN}
            </Descriptions.Item>
            <Descriptions.Item label={t('cbt.speakRubric.column3')}>{res?.data?.memo}</Descriptions.Item>
          </Descriptions>
        </div>
        <div className="comm-bx__between">
          <div className="comm-btn__area">
            <Button
              className="btn-basic gray-line"
              onClick={() => history.push('/cbt/speaking-rubric')}
              text={t('common.button.list')}
            />
          </div>
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink-line"
              onClick={createShowModal}
              text={t('common.button.add')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
        <SpeakingRubricItemTable
          data={res?.data?.items}
          showModal={showModal}
        />
      </div>

      {visible && (
        <ItemSaveModal
          visible={visible}
          onCancel={onCancel}
          disabled={res3?.data ?? true}
          data={res2?.data}
          rubricNo={+id}
          eduStepCode={res?.data?.eduStepCode || 'EM'}
        />
      )}
    </>
  );
};

export default CbtSpeakingRubricRead;
